interface IGoToUrlByFormProps {
    currentWindow: Window,
    method?: 'get' | 'post',
    params?: Record<string, number | string>,
    url: string,
}

function goToUrlByForm({ url, params = {}, method = 'post', currentWindow }: IGoToUrlByFormProps) {
    let form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", url);

    for (let key in params) {
        if (params.hasOwnProperty(key)) {
            const field = currentWindow.document.createElement("input");
            field.setAttribute("type", "hidden");
            field.setAttribute("name", key);
            field.setAttribute("value", `${params[key]}`);
            form.appendChild(field);
        }
    }

    currentWindow.document.body.appendChild(form);
    form.submit();
}

export default goToUrlByForm;
